import React, { useState } from 'react';
import PatientReportListTable from './table/PatientReportListTable';

const PatientReportListPage = () => {
    const [pageNumber, setPageNumber] = useState(1);
    const [pageLimit, setPageLimit] = useState(10);
    const [filterData, setFilterData] = useState({
        diseaseReportType: '',
        fromDate: '',
        toDate: '',
    });

    return (
        <div>
            <PatientReportListTable
                filterData={filterData}
                pageLimit={pageLimit}
                currentPageNumber={pageNumber}
                handlePageNumber={setPageNumber}
                setFilterData={setFilterData}
                setPageLimit={setPageLimit}
                setPageNumber={setPageNumber}
            />
        </div>
    );
};

export default PatientReportListPage;
